import Marionette from 'backbone.marionette';
import views from '../../views';

export default class OnboardingController extends Marionette.Object {

	/**
	 * Method for /onboarding
	 */
	onboarding() {
		const
			rootView        = this.getOption('rootView'),
			onboardingView = new views.OnboardingView({
				game_title: 'Tipping'
			});

		rootView.getRegion('main').show(onboardingView);
	}
}